import {registerCrudStore} from '@/libs/core/crud/register-crud-store';
import {TransactionModel} from '@/libs/Api';
import {TransactionsDataService} from '@/libs/transactions/transactions-data-service';
import {StoreName} from '@/libs/core/store/store-name';

export const transactionsStore = registerCrudStore<TransactionModel, TransactionModel>(StoreName.Transaction, new TransactionsDataService());
